import React from 'react';
import { useBrsCreateStyles } from '../BrsCreateStyles';

export const FormFooter = ({
  onCancel,
  onSubmit,
  onGeneratePdf,
  onAttachPdf,
  onRemoveAttachedPdf,
  attachedPdf,
  isSubmitting,
  submitBlocked,
  submitBlockedReason,
}) => {
  const classes = useBrsCreateStyles();
  const hasAttachedPdf = Boolean(attachedPdf);
  const blockTitle = submitBlocked ? submitBlockedReason : undefined;

  return (
    <div className={classes.formFooter}>
      <div className={classes.helpText}>All fields marked * are required</div>
      <div className={classes.footerActions} style={{ alignItems: 'center' }}>
        {hasAttachedPdf && (
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '6px 10px',
              borderRadius: 4,
              border: '1px solid rgba(60,231,234,0.4)',
              background: 'rgba(60,231,234,0.08)',
              fontSize: 12,
              color: '#3CE7EA',
              maxWidth: 240,
            }}
            title={attachedPdf.name}
          >
            <span
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {attachedPdf.name}
            </span>
            <button
              type="button"
              onClick={onRemoveAttachedPdf}
              disabled={isSubmitting}
              aria-label="Remove attached PDF"
              style={{
                background: 'none',
                border: 'none',
                color: 'inherit',
                cursor: 'pointer',
                fontSize: 16,
                lineHeight: 1,
                padding: 0,
              }}
            >
              &times;
            </button>
          </div>
        )}
        {onAttachPdf && (
          <button
            className={`${classes.btn} ${classes.btnGhost}`}
            onClick={onAttachPdf}
            type="button"
            disabled={isSubmitting}
          >
            {hasAttachedPdf ? 'Replace PDF' : 'Attach PDF'}
          </button>
        )}
        <button
          className={`${classes.btn} ${classes.btnGhost}`}
          onClick={onCancel}
          type="button"
          disabled={isSubmitting}
        >
          Cancel
        </button>
        {onGeneratePdf && (
          <button
            className={`${classes.btn} ${classes.btnGhost}`}
            onClick={onGeneratePdf}
            type="button"
            disabled={isSubmitting || hasAttachedPdf || submitBlocked}
            title={
              submitBlocked
                ? blockTitle
                : hasAttachedPdf
                  ? 'Remove the attached PDF to generate one instead'
                  : undefined
            }
          >
            Generate PDF
          </button>
        )}
        <button
          className={`${classes.btn} ${classes.btnPrimary}`}
          onClick={onSubmit}
          type="button"
          disabled={isSubmitting || submitBlocked}
          title={submitBlocked ? blockTitle : undefined}
        >
          {isSubmitting ? 'Submitting...' : 'Submit Job'}
        </button>
      </div>
    </div>
  );
};
